class Header {
	private imageContainer: NodeListOf<HTMLElement>;
	private readonly totalImages: number;
	private imagesLoaded: number;
	private currentImage: number;
	private transitionDuration: number = 12000;

	public constructor(target: HTMLElement) {
		this.imageContainer = target.querySelectorAll('.image-container');
		this.totalImages = this.imageContainer.length;
		this.currentImage = 0;
		this.imagesLoaded = 0;

		const images: NodeListOf<HTMLImageElement> =
			target.querySelectorAll('.image-container img');
		images.forEach((image: HTMLImageElement) => {
			if (image.complete) {
				this.imagesLoaded++;
			} else {
				image.addEventListener('load', () => this.onImageLoaded());
			}
		});

		this.checkImages();
	}

	private onImageLoaded(): void {
		this.imagesLoaded++;
		this.checkImages();
	}

	private checkImages(): void {
		if (this.imageContainer.length > 1 && this.imagesLoaded === this.totalImages) {
			this.startCountdown();
		}
	}

	private startCountdown(): void {
		window.setTimeout(() => this.updateGallery(), this.transitionDuration);
	}

	private updateGallery(): void {
		this.currentImage = this.currentImage < this.totalImages - 1 ? this.currentImage + 1 : 0;

		this.imageContainer.forEach((image: HTMLElement, index: number) => {
			if (this.currentImage === index) {
				image.classList.add('active');
			} else {
				image.classList.remove('active');
			}
		});

		this.startCountdown();
	}
}

const nodes: NodeListOf<HTMLElement> = document.querySelectorAll('.lp-header');
nodes.forEach((node: HTMLElement) => new Header(node));
